import {
  ATTACH_ACTION_SELECT_ACTION_FILE,
  ATTACH_ACTION_SELECT_FILE_FROM_STORAGE,
} from '../../../../AttachActionSelect'

export function getChatroomInputAttachActions({ t }) {
  return [
    {
      label: t('Chatroom.AttachFileActionOptionKey'),
      value: ATTACH_ACTION_SELECT_ACTION_FILE,
    },
    {
      label: t('Chatroom.AttachFileFromStorageActionOptionKey'),
      value: ATTACH_ACTION_SELECT_FILE_FROM_STORAGE,
    },
  ]
}
